module.exports = __webpack_public_path__ + "static/media/abicon4.19a66364.webp";